export const buzz = (ms = 8) => {
  try {
    if (navigator.vibrate) navigator.vibrate(ms);
  } catch {
    /* noop */
  }
};
